<template>
  <div>
    <h3>Gäste im {{ property }}</h3>
    <el-button @click="startstop" :icon="icon" circle></el-button>
    <el-button @click="dialogFormVisible = true" icon="el-icon-setting" :disabled=dialogButtonActive circle></el-button>
    <el-dialog title="Einstellungen" :visible.sync="dialogFormVisible">
      <el-form :model="interval">
        <el-form-item label="Interval in MS:" label-width="120px">
          <el-input v-model="interval.interval_ms"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">Schließen</el-button>
      </span>
    </el-dialog>
    <div class="table">
      <el-table
      :data="inHouse"
      stripe
      :default-sort = "{prop: 'unit.name', order: 'ascending'}">
        <el-table-column
          prop="unit.name"
          label="Nummer">
        </el-table-column>
        <el-table-column
          prop="primaryGuest.lastName"
          label="Nachname">
        </el-table-column>
        <el-table-column
          prop="primaryGuest.firstName"
          label="Vorname">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      inHouse: null,
      tokenMan: null,
      selected: null,
      interval: {
        interval: null,
        interval_ms: 60000,
        running: null
      },
      icon: 'el-icon-video-play',
      x: 0,
      dialogFormVisible: false,
      dialogButtonActive: false
    }
  },
  computed: {
    ...mapGetters({
      token: 'getAuthToken',
      property: 'getProperty'
    })
  },
  methods: {
    getReservations () {
      // Fetching the reservations from the Apaleo API
      console.log('FETCHING RESERVATIONS')
      const apiURL = 'https://api.apaleo.com/booking/v1/reservations?status=InHouse&propertyIds=' + this.property
      const auth = this.token
      axios.get(apiURL, { headers: { 'Authorization': auth } })
        .then(response => {
          this.inHouse = response.data.reservations
        })
        .catch(error => {
          // Note: If the token is invalid, we refetch a token and retry the getReservations() call until the new token is available
          this.$store.dispatch('getAuthToken')
          this.getReservations()
          console.log(error)
        })
    },
    runInterval () {
      // We need to refetch the data of the Apaleo API in regular intervals, to assure that the latest guests are shown
      if (this.property) {
        console.log('Recurring fetch of transaction data started')
        this.interval.running = true
        this.icon = 'el-icon-video-pause'
        this.dialogButtonActive = true
        this.getReservations()
        this.interval.interval = setInterval(this.getReservations, this.interval.interval_ms)
      } else {
        this.$message.error('Kein Property ausgewählt!')
      }
    },
    startstop () {
      if (this.interval.running === true) {
        clearInterval(this.interval.interval)
        this.icon = 'el-icon-video-play'
        this.dialogButtonActive = false
        this.interval.running = false
      } else {
        this.runInterval()
      }
    }
  },
  mounted () {
    this.runInterval()
  },
  beforeDestroy () {
    clearInterval(this.interval.interval)
  }
}
</script>

<style scoped>
.table {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  max-width: 50em;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}
</style>
